import React, { Component } from "react";
import { Mutation, Query } from "react-apollo";
import gql from "graphql-tag";
import { connect } from "react-redux";
import { TextField } from "office-ui-fabric-react/lib/TextField";

class ShipmentInfoTextField extends Component {
  render() {
    const { shipment } = this.props;
    const id = shipment.id;
    return (
      <Query query={SHIPMENT_STATUS} variables={{ id }}
      // pollInterval={25000}
      >
        {({ loading, error, data }) => {
          if (loading) return "Loading...";
          if (error) return `Error! ${error.message}`;

          const status =
            data && data.shipmentById && data.shipmentById.status
              ? JSON.parse(data.shipmentById.status)
              : "";

          return (
            <Mutation mutation={UPDATE_SHIPMENT_STATUS}>
              {(mutate, { m_data }) => (
                <TextField
                  style={{
                    backgroundColor: "#CED3DC",
                    height: "30px",
                    fontSize: "large",
                    fontWeight: "bold"
                  }}
                  placeholder="shipment info"
                  value={status && status.info ? status.info : ''}
                  resizable={false}
                  onBlur={e => {
                    e.preventDefault();
                    mutate({
                      variables: {
                        id: id,
                        status: JSON.stringify({
                          ...status,
                          info: e.target.value
                        })
                      }
                    });
                  }}
                />
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

const SHIPMENT_STATUS = gql`
  query shipmentById($id: Int!) {
    shipmentById(id: $id) {
      id
      about
      status
    }
  }
`;
const UPDATE_SHIPMENT_STATUS = gql`
  mutation($id: Int!, $status: JSON) {
    updateShipmentById(input: { id: $id, shipmentPatch: { status: $status } }) {
      shipment {
        id
        status
      }
    }
  }
`;

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(ShipmentInfoTextField);



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentInfoTextField.js